module.exports = __webpack_public_path__ + "img/content-bkg.66b31253.png";